import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import { AUTH_STATUS_NEW } from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListNewInvoice = () => {
  const [filterList, setFilterList] = useState({
    "filter[auth_status]": AUTH_STATUS_NEW,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        screenFilterCode={SCREEN_FILTER_CODE.INVOICE_NEW}
        listStatusFilter={[AUTH_STATUS_NEW]}
        title={"DANH SÁCH HÓA ĐƠN LƯU TẠM"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListNewInvoice;
